import {
  SET_CURRENT_CREW_FILE,
  SET_EXPERIENCE,
  SET_INVITE_TRIP,
  SET_IS_MORE_TRIPS,
  SET_TRIP_INVITATIONS,
  SET_TRIPS
} from "./logbook-types";

export const setTrips = (trips) => ({type: SET_TRIPS, trips})
export const setInviteTrip = (inviteTrip) => ({type: SET_INVITE_TRIP, inviteTrip})
export const setCurrentCrewFile = (currentCrewFile) => ({type: SET_CURRENT_CREW_FILE, currentCrewFile})
export const setTripInvitations = (tripInvitations) => ({type: SET_TRIP_INVITATIONS, tripInvitations})
export const setExperience = (experience) => ({type: SET_EXPERIENCE, experience})

export const setIsMoreTrips = (isMoreTrips) => ({type: SET_IS_MORE_TRIPS, isMoreTrips})
